import Api from '@/api'


const fetchAll = () => {	
    return Api.get('api/companies')
};

const postForm =  (payload,id) => {  
    
    if(typeof id != "undefined") {        
        return Api.put('api/companies/' + id , payload)       
    } else {
        return Api.post('api/companies' , payload)       
    }
    
};

const getById =  (payload) => {        
    return Api.get('api/companies/' + payload)       
};


export default {
  fetchAll,
  postForm,
  getById
};